/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScheduleListItemResponseDto } from './ScheduleListItemResponseDto';
import {
    ScheduleListItemResponseDtoFromJSON,
    ScheduleListItemResponseDtoFromJSONTyped,
    ScheduleListItemResponseDtoToJSON,
    ScheduleListItemResponseDtoToJSONTyped,
} from './ScheduleListItemResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListSchedulesResponseDto
 */
export interface ListSchedulesResponseDto {
    /**
     * 
     * @type {Array<ScheduleListItemResponseDto>}
     * @memberof ListSchedulesResponseDto
     */
    data: Array<ScheduleListItemResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListSchedulesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListSchedulesResponseDto interface.
 */
export function instanceOfListSchedulesResponseDto(value: object): value is ListSchedulesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListSchedulesResponseDtoFromJSON(json: any): ListSchedulesResponseDto {
    return ListSchedulesResponseDtoFromJSONTyped(json, false);
}

export function ListSchedulesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSchedulesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ScheduleListItemResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListSchedulesResponseDtoToJSON(json: any): ListSchedulesResponseDto {
    return ListSchedulesResponseDtoToJSONTyped(json, false);
}

export function ListSchedulesResponseDtoToJSONTyped(value?: ListSchedulesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ScheduleListItemResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

